/** Build-target flags for the desktop app (Neo Dub Desktop).
 *
 * This codebase serves the browser and the desktop shell alike — there is
 * no fork. NEODUB_TARGET=desktop switches on the handful of build-time
 * differences a static export needs; see next.config.ts and
 * Neo_Dub_Desktop/DECISION_ORIGIN_AUTH.md.
 *
 * DESKTOP_BUILD reads NEXT_PUBLIC_NEODUB_TARGET, not NEODUB_TARGET — on
 * purpose, and the two are NOT interchangeable. Next.js only guarantees a
 * `process.env.X` reference is inlined into code that genuinely runs in
 * the browser when X is `NEXT_PUBLIC_`-prefixed; a bare var is reliably
 * available during server-side prerendering (Node.js, real env) but is
 * NOT dependable inside a "use client" component whose render is gated
 * behind client-only state — e.g. account/page.tsx's
 * `if (!auth.isSuccess) return null`, which means that page's real content
 * (and everything DESKTOP_BUILD gates inside it) renders ONLY after
 * hydration, in the browser, where a bare env var is simply absent. Found
 * the hard way: a first pass at the desktop nav/credits trim used the bare
 * var and silently did nothing on any page gated like that — the login
 * page (not gated) made it LOOK like it worked. build-frontend.sh sets
 * both vars; next.config.ts still reads the bare one (config code always
 * runs in Node, this trap does not apply there).
 */
export const DESKTOP_BUILD = process.env.NEXT_PUBLIC_NEODUB_TARGET === "desktop";

/** A static export cannot prerender /projects/[id] without being handed a
 * list of ids, and the ids only exist at runtime. So the desktop build
 * prerenders the route ONCE under this placeholder, and the shell serves
 * those bytes for any real project id with the placeholder substituted —
 * a parameter hole in a prerendered shell, filled by the server that owns
 * it. Next bakes the value into the flight payload as
 * `"params":{"id":"..."}`, which is exactly what the substitution fixes.
 *
 * MUST stay identical to PROJECT_ID_SENTINEL in
 * Neo_Dub_Desktop/src-tauri/src/server.rs. Deliberately a string that
 * cannot occur as a real project id (they are UUIDs).
 */
export const DESKTOP_PROJECT_ID_SENTINEL = "__NEODUB_PROJECT_ID__";
